import { render } from "./cephfs.vue?vue&type=template&id=87a03370"
import script from "./cephfs.vue?vue&type=script&lang=js"
export * from "./cephfs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__